import styled from 'styled-components';

import {
  Input as SemanticInput,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  cursor: move;
  width: 100%;
  height: min-content;
  min-height: 150px;
  transition: 0.2s;
  opacity: ${({ opacity }) => opacity}
  border-radius: 2px;
  background: ${({ theme }) => theme.color.cardSortBackground};
  padding: 15px 15px 30px 15px;
  :first-child {
    margin-left: 0;
  }
  :last-child {
    margin-right: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  height: fit-content;
  min-height: 40px;
  justify-content: space-between;
`;

export const Link = styled.a``;

export const Text = styled(TextLayoutComponent)`
  word-break: break-word;
`;

export const Icon = styled(SemanticIcon)`
  cursor: pointer;
  padding: 0 5px;
`;

export const Input = styled(SemanticInput)`
  &.ui.input input {
    font-size: 14px;
    color: ${(props) => props.theme.color.inputColor}
  }
  max-width: 250px;
`;
